import React, {useState} from 'react';
import purify from 'dompurify';
import { ArticleContentComponent } from '../../Shared/Scripts/Components/ArticleContentComponent';
import { ModalCompontent } from '../../Shared/Scripts/Components/ModalComponent';
import VeilederRenterDto from '../Models/VeilederRenterDto';

interface Props {
    side: VeilederRenterDto;
}

export default function BoksA(props: Props): JSX.Element {

    const [visModal, setVisModal] = useState(false);

    function onModalClick(): void {
        setVisModal(true);
    }

    function onRequestLukkModal(): void {
        setVisModal(false);
    }

    return (
            <div className="c-veileder__panel c-veileder__panel--input-white c-veileder--skjul-trekant">
                {props.side.gulSirkel && <div className="c-sirkel c-sirkel-tilpasset">{props.side.gulSirkel}</div>}
                <div className="c-veileder__panel-row">
                    <div className="c-veileder__content">
                        <h3 className="c-veileder--overskrift c-veileder--overskrift-stor c-veileder--overskrift-sirkel-overstyrer">
                            {props.side.overskriftBoksA}
                        </h3>
                    </div>
                </div>
                <div className="c-veileder__panel-row">
                    <div className="c-veileder__content">
                        <div className="c-veileder__content--textarea">
                            <div className="c-veileder--tekstomraade" dangerouslySetInnerHTML={{ __html: purify.sanitize(props.side.tekstBoksA?.value) }} />
                            <button type="button" className="c-knapp c-knapp--lenke c-knapp--lenke-aubergine" onClick={onModalClick}>
                                {props.side.modalFastsettelseLenketekst}
                            </button>
                            <ModalCompontent
                                isOpen={visModal}
                                onRequestClose={onRequestLukkModal}
                                ariaCloseText={props.side.modalFastsettelseLukkTekst}
                            >
                                <ArticleContentComponent
                                    headerinnhold={<span>{props.side.modalFastsettelseTittel}</span>}
                                    contentinnhold={<div dangerouslySetInnerHTML={{ __html: purify.sanitize(props.side.modalFastsettelseTekst?.value)}} />}
                                />
                            </ModalCompontent>   
                        </div> 
                    </div>
                    <div className="c-veileder__content c-veileder__content--indented">
                        <div className="c-veileder__content--inputarea">
                            <h4 className="c-veileder__undersporsmal">{props.side.overskriftFlytendeRente}</h4>
                            <div className="c-veileder__content-section">
                                <div className="c-veileder__resultat-tekst">{props.side.flytendeRente}</div>
                                <div>{props.side.typeRente}</div>
                            </div>
                        </div>
                        <div className="c-veileder--tekstomraade-uten-margin">{props.side.renteStottetekst}</div>
                    </div>
                </div>
            </div>
    )
}
